import { BUTTON_STYLE_ROUNDED } from '../../../utils/constants';

export default {
  namespaced: true,
  state: {
    theme: null,
    auth0: {},
    email: {},
    scoreboard: {},
    whiteLabel: {},
    orgProfile: {},
    calculator: {},
    message: ''
  },
  getters: {
    getOrgProfile(state) {
      return state.orgProfile;
    },
    isNZ(state) {
      return state.orgProfile?.whiteLabel?.region === 'NZ';
    },
    theme(state) {
      return state.theme;
    },
    getScoreboard(state) {
      return state.scoreboard;
    },
    getWhitelabel(state) {
      return state.whiteLabel;
    },
    getCalculator(state) {
      return state.calculator;
    },
    getIsCalculatorButtonRounded(state, getters) {
      const calculator = getters.getCalculator;
      const style = calculator?.buttonStyle || BUTTON_STYLE_ROUNDED;

      return style === BUTTON_STYLE_ROUNDED;
    },
    ratebookOrgId(state, getters, rootState) {
      return state.orgProfile?.pricingConfiguration?.calculator?.ratebookOrgId;
    },
    getMessage(state) {
      return state.message;
    }
  },
  mutations: {
    setProfile(state, profile) {
      state.scoreboard = profile.scoreboard;
      state.auth0 = profile.auth0;
      state.email = profile.email;
      state.whiteLabel = profile.whiteLabel;
      state.orgProfile = profile;
    },
    setCalculator(state, calculator) {
      state.calculator = calculator;
    },
    setMessage(state, message) {
      state.message = message;
    },
    clearMessage(state) {
      state.message = '';
    }
  },
  actions: {
    clearTheme(state) {
      state.theme = null;
    },
    setTheme(state, theme) {
      state.theme = theme;
    }
  }
};
